/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStrategy,
    JsonStrategyFromJSON,
    JsonStrategyFromJSONTyped,
    JsonStrategyToJSON,
} from './JsonStrategy';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStrategy
 */
export interface ApiResultOfJsonStrategy {
    /**
     * 
     * @type {JsonStrategy}
     * @memberof ApiResultOfJsonStrategy
     */
    data?: JsonStrategy;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategy
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStrategy
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategy
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategy
     */
    result?: ApiResultOfJsonStrategyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStrategyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStrategyFromJSON(json: any): ApiResultOfJsonStrategy {
    return ApiResultOfJsonStrategyFromJSONTyped(json, false);
}

export function ApiResultOfJsonStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStrategy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStrategyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStrategyToJSON(value?: ApiResultOfJsonStrategy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStrategyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

